// Per-route search meta from the artifact. The router's beforeEach appends " | DIGU"
// to meta.title, so titles here are stored without that suffix.
import { ROUTES } from './routes';

const OG_IMAGE = 'https://digu.one/img/Digu_Logo_Primary.a2e37f8d.webp';
const SITE = 'https://www.digu.one';

const PAGES = {
  home: {
    path: ROUTES.home,
    title: 'Claude Code and AI coding agent security',
    description:
      'DIGU secures Claude Code and the other AI coding agents your engineers use. 32 controls, built in your environment, with evidence your auditors accept.',
  },
  services: {
    path: ROUTES.services,
    title: 'Claude Code security services and consulting',
    description:
      'Five fixed-fee engagements to secure Claude Code and other AI coding agents, from a one week assessment to a monthly retainer. No hourly rates.',
  },
  assessment: {
    path: ROUTES.assessment,
    title: 'Claude Code security assessment in one week',
    description:
      'One week. We score your Claude Code and AI agent usage against 32 controls using your own data, and give you a costed ninety day plan.',
  },
  score: {
    path: ROUTES.score,
    title: 'Free AI coding agent security score',
    description:
      'Ten questions, two minutes. Get your profile across five control domains, your floor, and the three fixes that matter most. No call required.',
  },
  roadmap: {
    path: ROUTES.roadmap,
    title: 'AI agent security maturity model, five levels',
    description:
      'Five levels, scored across five control domains. See how many of the 32 controls each level needs, and what each level lets you safely do next.',
  },
  baseline: {
    path: ROUTES.baseline,
    title: 'AI agent security baseline: 32 controls',
    description:
      'The DIGU AI Security Baseline. 32 controls in five domains, each with an implementation and its evidence, mapped to OWASP, NIST AI RMF and ISO/IEC 42001.',
  },
  about: {
    path: ROUTES.about,
    title: 'About DIGU, AI coding agent security engineers',
    description:
      'DIGU is Certified in the Claude Partner Network and is an Okta partner. Certified Claude engineers on every project, and a published control baseline.',
  },
};

const KEYWORDS =
  'DIGU, Claude Code security, AI coding agent security, Claude Partner Network, Okta partner, OWASP Top 10 for Agentic Applications, NIST AI RMF, ISO/IEC 42001';

// Route meta in the shape src/router/index.js beforeEach already reads.
export const seoMeta = (key) => {
  const p = PAGES[key];
  return {
    title: p.title,
    description: p.description,
    keywords: KEYWORDS,
    og: { title: `${p.title} | DIGU`, description: p.description, url: SITE + p.path, image: OG_IMAGE },
    twitter: { title: `${p.title} | DIGU`, description: p.description, image: OG_IMAGE },
  };
};
